import { FormikProps } from 'formik';
import { FC } from 'react';
import { Switch } from 'shared/ui';
import Divider from 'components/Divider';
import { HexColorInput } from 'react-colorful';
import ColorSelect from 'shared/ui/ColorSelect/ColorSelect';
import { truncateText } from 'shared/lib';
import SelectInput from 'components/shared/SelectInput';
import { ITavusPersonaFormik } from 'entities/tavus/persona';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
}
export const InterfaceSettings: FC<IProps> = ({ formik }) => {
  return (
    <>
      <div className="ag-flex ag-justify-between">
        <label
          className="ag-cursor-pointer ag-flex ag-items-center ag-gap-2"
          htmlFor="main-color"
        >
          <div className="ag-text-neutral-700 ag-font-medium">Main color</div>
        </label>
        <div className="ag-flex ag-gap-1">
          <HexColorInput
            prefixed
            color={formik.values.embed.main_color}
            onChange={(color) =>
              formik.setFieldValue('embed.main_color', color)
            }
            className="ag-h-8 ag-max-w-24 ag-rounded-lg ag-border ag-border-neutral-200 ag-py-1.5 ag-px-3"
          />
          <ColorSelect
            pickerClassName="-ag-ml-48"
            className="ag-w-8 ag-h-8 ag-rounded-lg ag-border ag-border-neutral-200"
            color={formik.values.embed.main_color}
            onChange={(color) => {
              formik.setFieldValue('embed.main_color', color);
            }}
          />
        </div>
      </div>
      {/* <Divider />
      <div className="ag-flex ag-items-center ag-justify-between">
        <span className="ag-text-neutral-700 ag-font-medium">Dark Mode</span>
        <Switch
          onChange={(value) => formik.setFieldValue('embed.dark_mode', value)}
          checked={formik.values.embed.dark_mode}
        />
      </div> */}
      <Divider />
      <div className="ag-flex ag-items-center ag-justify-between">
        <span className="ag-text-neutral-700 ag-font-medium">Font</span>
        <SelectInput
          name="select-language"
          options={[
            'Roboto',
            'Open Sans',
            'Lato',
            'Montserrat',
            'Poppins',
            'Raleway',
            'Oswald',
            'Merriweather',
            'Playfair Display',
            'Inter'
          ]}
          value={truncateText(formik.values.embed.font, 7)}
          onChange={(value) => formik.setFieldValue('embed.font', value)}
          optionsWrapperClassName="!ag-bg-white !ag-border-neutral-200 ag-left-auto ag-right-0 ag-h-[150px]"
          className="ag-h-8 !ag-bg-white !ag-border-neutral-200 !ag-text-neutral-700"
          wrapperClassName="!ag-bg-white !ag-text-neutral-700 !ag-border-neutral-200 !ag-w-28"
          optionsClassName="ag-text-neutral-700 ag-border-neutral-200 ag-text-sm ag-py-1 hover:ag-bg-neutral-200/80 dark:hover:ag-bg-[#262626]/80"
        />
      </div>
      <Divider />
      <div className="ag-flex ag-items-center ag-justify-between">
        <span className="ag-text-neutral-700 ag-font-medium">Camera</span>
        <Switch
          onChange={(value) => formik.setFieldValue('embed.camera', value)}
          checked={formik.values.embed.camera}
        />
      </div>
      <div className="ag-flex ag-items-center ag-justify-between">
        <span className="ag-text-neutral-700 ag-font-medium">Screen share</span>
        <Switch
          onChange={(value) =>
            formik.setFieldValue('embed.screen_share', value)
          }
          checked={formik.values.embed.screen_share}
        />
      </div>
      <div className="ag-flex ag-items-center ag-justify-between ag-flex-wrap">
        <span className="ag-text-neutral-700 ag-font-medium">
          Language selection
        </span>
        <Switch
          onChange={(value) =>
            formik.setFieldValue('embed.language_selection', value)
          }
          checked={formik.values.embed.language_selection}
        />
      </div>
      <div>
        <div className="ag-flex ag-items-center ag-justify-between ag-flex-wrap">
          <span className="ag-text-neutral-700 ag-font-medium">
            Captions by default
          </span>
          <Switch
            onChange={(value) =>
              formik.setFieldValue('embed.captions_by_default', value)
            }
            checked={formik.values.embed.captions_by_default}
          />
        </div>
        <div className="ag-text-neutral-600 ag-text-sm">
          If disabled, users need to enable them from the menu
        </div>
      </div>
    </>
  );
};
